import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { AddUserComponent } from 'src/app/modules/users/pages/add-user/add-user.page';
import { TaggerListComponent } from 'src/app/modules/users/pages/tagger-list/tagger-list.page';
import { UserDetailComponent } from 'src/app/modules/users/pages/user-detail/user-detail.page';
import { UsersListComponent } from 'src/app/modules/users/pages/users-list/users-list.page';
var ɵ0 = {
    permissions: ['canReadUsersList']
}, ɵ1 = {
    permissions: ['canCreateUsers']
}, ɵ2 = {
    permissions: ['canCreateUsers']
}, ɵ3 = {
    permissions: ['canCreateUsers']
}, ɵ4 = {
    permissions: ['canReadUsersList']
};
var routes = [
    {
        path: 'list',
        component: UsersListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: 'detail/:userId',
        component: UserDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ1,
    },
    {
        path: 'detail/:userId/:adminCompanyId',
        component: UserDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: 'add',
        component: AddUserComponent,
        canActivate: [RoleGuard],
        data: ɵ3,
    },
    {
        path: 'tagger',
        component: TaggerListComponent,
        canActivate: [RoleGuard],
        data: ɵ4,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var UsersRoutingModule = /** @class */ (function () {
    function UsersRoutingModule() {
    }
    return UsersRoutingModule;
}());
export { UsersRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
